<template>
<div class="stores-popup" v-if="active">
  <div class="content">
    <svg
        @click="function() {active = false}"
        class="close"
        xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path d="M18 6.34096L6 18.3409M18 18.3408L6 6.34088" stroke="#999999" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div class="head">
      <span class="title">Наличие</span>
    </div>
    <div class="body">
      <div class="stores_list">
        <div class="item" v-for="item in storesData.list" :key="item">
          <span class="name">{{item.name}}</span>
          <span class="quantity" :class="[{not_aviable: item.quantity == 0}]">
            <span v-show="item.quantity > 0">{{item.quantity}}</span>
            <span v-show="item.quantity > 0"> шт</span>
            <span v-show="item.quantity <= 0">Нет в наличии</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>

export default {
  name : "StoresPopup",
  props : {

  },
  data() {
    return{
      active : false,

      storesData : [
        {name : "Витрина НИТИ, Рязань, пр. Яблочкова, д. 8 \"Ж\"", quantity : 18},
        {name : "СКЛАД 1, Рязань, пр. Яблочкова, д. 8 \"Ж\"", quantity : 0},
        {name : "СКЛАД 2, Рязань, пр. Яблочкова, д. 8 \"Ж\"", quantity : 121},
        {name : "СКЛАД 3, Рязань, пр. Яблочкова, д. 8 \"Ж\"\n", quantity : 10},
        {name : "Сервисный склад, Рязань, пр. Яблочкова 8Д\n", quantity : 0},
        {name : "Склад УЛИЦА , Рязань, пр. Яблочкова, д. 8 \"Ж\"", quantity : 3},
        {name : "Тула, Городской переулок, 17А", quantity : 0},
      ]
    }
  },
}
</script>

<style scoped>
.stores-popup{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(34, 34, 34, 0.60);
  z-index: 100;
}

.content {
  width: 620px;
  height: 531px;
  border-radius: 8px;
  background: var(--White, #FFF);
  position: absolute;
  left: calc(50% - 310px);
  top: 150px;
  padding: 30px;
  box-sizing: border-box;
  position: relative;
}

.head {
  margin-bottom: 20px;
}

.close {
  position: absolute;
  right: 14px;
  top: 13px;
  cursor: pointer;
}

.title {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
}

.content .body {
  height: 100%;
}

.stores_list {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  overflow: auto;
  height: 100%;
  height: calc(100% - 60px);
}

.stores_list .item {
  padding: 19px 18px 20px 18px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--Border, #EDEDED);
}

.stores_list .item:last-child {
  border-bottom: unset;
}

.stores_list .item .name{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  flex: 1;
}

.stores_list .item .quantity{
  color: var(--Green, #69BE15);
  text-align: right;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}

.stores_list .item .quantity.not_aviable {
  color: var(--Red, #FA4B61);
}



.stores_list::-webkit-scrollbar {
  width: 3px; /* Ширина всего элемента навигации */
}

.stores_list::-webkit-scrollbar-track {
  background: #fff; /* Цвет дорожки */
}

.stores_list::-webkit-scrollbar-thumb {
  background: var(--Gray, #656565); /* Цвет бегунка */
  border-radius: 20px; /* Округление бегунка */
  border: 3px solid var(--Border, #EDEDED); /* Оформление границ бегунка */
}



/*MOBILE*/
@media (max-width: 1250px)
{
  .stores-popup {

  }

  .content {
    width: auto;
    height: auto;
    left: unset;
    padding: 18px;
    margin: 15px;
    top: 100px;
  }

  .title {
    font-size: 18px;
  }

  .stores_list {
    flex-direction: column;
    height: 400px;
    overflow: auto;
  }

  .stores_list .item {
    padding: 10px 14px;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 6px;
  }

  .stores_list .item .name{
    font-size: 14px;
  }

  .stores_list .item .quantity{
    font-size: 14px;
  }
}
</style>